import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageBreadcrumb from "../common/PageBreadCrumb";
import PageMeta from "../common/PageMeta";
import ComponentCard from "../common/ComponentCard";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import Radio from "../form/input/Radio";
import TextArea from "../form/input/TextArea";
import Select from "../form/Select";
import Button from "../ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import { CheckLineIcon, CloseLineIcon } from "../../icons";
import { createSubscription, resetcreateSubscription, emptyReduxSubscription } from "../../actions/subscriptionAction";
import { checkAuth, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';

export default function AddPlan() {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const createdNewSubscriptionRes = useSelector(state => state.subscriptionReducer.createSubscriptionPlan);

  const createdNewSubscriptionFailed = useSelector(state => state.subscriptionReducer.createSubscriptionPlanFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const [showLoginLoader, setShowLoginLoader] = useState(false);
  
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const [title, setTitle] = useState("");
  const [errorTitle, setErrorTitle] = useState(false);

  const [description, setDescription] = useState("");
  const [errorDescription, setErrorDescription] = useState(false);

  const [schedule, setSchedule] = useState("");
  const [errorSchedule, setErrorSchedule] = useState(false);

  const [tenure, setTenure] = useState("");
  const [errorTenure, setErrorTenure] = useState(false);

  const [amount, setAmount] = useState("");
  const [errorAmount, setErrorAmount] = useState(false);

  const [scheduleType, setScheduleType] = useState("fixed");
  const [errorScheduleType, setErrorScheduleType] = useState(false);


  const [scheduleOptions, setScheduleOptions] = useState([
    { value: "weekly", label: "weekly" },
    { value: "monthly", label: "monthly" },
    { value: "yearly", label: "yearly" },
  ]);

  const fixed_scheduleOptions = [
    { value: "weekly", label: "weekly" },
    { value: "monthly", label: "monthly" },
    { value: "yearly", label: "yearly" },
  ];

  useEffect(() => {
    dispatch(checkAuth());
  }, []);
 

  useEffect(() => {

    if(checkAuthFailed.statusCode == 401){
      //toast.error(checkAuthFailed.message, {autoClose:2000,onClose: () => {
            dispatch(emptyReduxUser());
            dispatch(emptyReduxSubscription());
            logout();
            navigate("/signin");
      //}});
    }

  }, [checkAuthFailed]);
  

  useEffect(() => {
    
    if(typeof createdNewSubscriptionRes != "undefined" && createdNewSubscriptionRes.statusCode == 200){

      setTitle("");
      setErrorTitle(false);
      setDescription("");
      setErrorDescription(false);
      setSchedule("");
      setErrorSchedule(false);
      setTenure("");
      setErrorTenure(false);
      setAmount("");
      setErrorAmount(false);

      //setShowSuccessAlert(true);
      toast.success("New subscription plan successfully created.", {
                            position: "bottom-right",
                            autoClose: 4000,
      });
      setShowLoginLoader(false);
      setTimeout(() => {
        navigate('/subscription/all'); // or any other route
      }, 2000);
      // setTimeout(() => {
      //   setShowSuccessAlert(false);
      // },6000);
    }

  }, [createdNewSubscriptionRes]);


  useEffect(() => {
    // console.log(getBotOperatorFailed);
    if(createdNewSubscriptionFailed.statusCode == 401){
          //toast.error(createdNewSubscriptionFailed.message, {autoClose:6000,onClose: () => {
                //dispatch(emptyRedux());
                logout();
                navigate("/login");
          //}});
    }
  }, [createdNewSubscriptionFailed]);


  const handleChangeNew = (input, event) => {
    
    var value = (input == "schedule" || input == "description" || input == "scheduleType") ? event : event.target.value;

    if(input == "title"){
        setTitle(value);
    }

    if(input == "description"){
        setDescription(value);
    }

    if(input == "scheduleType"){
      setScheduleType(value);

      if(value === "flexible"){

        let prevScheduleOptions = scheduleOptions;

        setScheduleOptions([]);

        setSchedule("");
        setErrorSchedule(false);
        setTenure("");
        setErrorTenure(false);
        setAmount("");
        setErrorAmount(false);
        
      }
      else{
        setScheduleOptions(fixed_scheduleOptions);
      }
    }

    if(input == "schedule"){
        setSchedule(value);
    }

    if(input == "tenure"){
        setTenure(value);
    }

    if(input == "amount"){
        setAmount(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setErrorTitle(false);
    setErrorDescription(false);
    setErrorSchedule(false);
    setErrorTenure(false);
    setErrorAmount(false);


    var err = [];
    if(title.replace(/\s/g, '') == ""){
      err.push("Title");
      setErrorTitle(true);
    }

    if(description.replace(/\s/g, '') == ""){
      err.push("Description");
      setErrorDescription(true);
    }

    if(scheduleType === "fixed"){
      
      if(schedule.replace(/\s/g, '') == ""){
        err.push("Schedule");
        setErrorSchedule(true);
      }

      if(tenure.replace(/\s/g, '') == ""){
        err.push("Tenure");
        setErrorTenure(true);
      }

      if(amount.replace(/\s/g, '') == ""){
        err.push("Amount");
        setErrorAmount(true);
      }
    }
    
    if(err.length === 0){
        let data = {
          "name" : title,
          "description": description,
          "scheduleType" : scheduleType,
          "tenure" : tenure,
          "amount" : amount,
          "schedule" : schedule,
          "createdBy": 1
        };

        if(scheduleType === "flexible"){
          data.tenure = null;
          data.amount = null;
          data.schedule = null;
        }

        setShowLoginLoader(true);

        dispatch(createSubscription(data));
    }
    else{
      //toast.error("Invalid data. Please fill all the fields properly.", {position: "bottom-right", autoClose:4000});
    }
  };

  const resetForm = (e) => {
      e.preventDefault();
      setTitle("");
      setErrorTitle(false);
      setDescription("");
      setErrorDescription(false);
      setSchedule("");
      setErrorSchedule(false);
      setTenure("");
      setErrorTenure(false);
      setAmount("");
      setErrorAmount(false);
  }
  
  return (
    <div>
      <PageMeta
        title="Add subscrioption plan | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Subscription plan" />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
        <div className="space-y-12">
          <ComponentCard title="Add New Plan">

          {(
            showSuccessAlert 

            ? 

            <Alert
              variant="success"
              title="Done!"
              message="New subscription plan successfully created."
              showLink={false}
            />

            : 
            
            null
          )}
          
          <form onSubmit={handleSubmit} className='fadein'>
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
              <div className="space-y-6">

                <div>
                  <Label>Title <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Title" 
                    error={errorTitle}
                    value={title} 
                    onChange={(e) => handleChangeNew("title", e)} 
                    hint={errorTitle ? "This field is required." : ""} 
                  />
                </div>

                <div>
                  <Label>Description <span className="text-red-500">*</span></Label>
                  <TextArea 
                    placeholder="Enter the details about subscription plan" 
                    error={errorDescription}
                    value={description} 
                    onChange={(e) => handleChangeNew("description", e)} 
                    hint={errorDescription ? "This field is required." : ""} 
                  />
                </div>

              </div>

              <div className="space-y-6">
              <div>
                <Label>Plan Type</Label>
                <div className="flex flex-wrap items-center gap-8">
                      <Radio
                        name="scheduleType"
                        value="fixed"
                        checked={scheduleType === "fixed"}
                        onChange={(e) => handleChangeNew("scheduleType", e)}
                        label="Fixed"
                      />
                      <Radio
                        name="scheduleType"
                        value="flexible"
                        checked={scheduleType === "flexible"}
                        onChange={(e) => handleChangeNew("scheduleType", e)}
                        label="Flexible"
                      />
                </div>
              </div>
              <div>
                  <Label>Schedule</Label>
                  <Select
                    options={scheduleOptions}
                    placeholder="Select an option"
                    error={errorSchedule}
                    onChange={(e) => handleChangeNew("schedule", e)}
                    className="dark:bg-dark-900"
                    hint={errorSchedule ? "This field is required." : ""}
                    disabled={scheduleType === "flexible"}
                    value={schedule}
                  />
                </div>
                <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
                  <div className="space-y-6">
                    <div>
                      <Label>Tenure</Label>
                      <Input 
                        type="number" 
                        step={1} 
                        placeholder="No of tenure" 
                        error={errorTenure}
                        value={tenure} 
                        onChange={(e) => handleChangeNew("tenure", e)} 
                        hint={errorTenure ? "This field is required." : ""} 
                        disabled={scheduleType === "flexible"}
                      />
                    </div>
                  </div>
                  <div className="space-y-6">
                    <div>
                      <Label htmlFor="tm">Subscription Amount</Label>
                      <div className="relative">
                        <Input
                          type="number"
                          placeholder="Amount"
                          className="pl-[62px]"
                          step={0.01}
                          error={errorAmount}
                          value={amount}
                          onChange={(e) => handleChangeNew("amount", e)}
                          hint={errorAmount ? "This field is required." : ""} 
                          disabled={scheduleType === "flexible"}
                        />
                        <span className="absolute left-0 top-1/2 flex h-11 w-[46px] -translate-y-1/2 items-center justify-center border-r border-gray-200 dark:border-gray-800">
                          <svg fill="#000" width="20" height="20" viewBox="0 0 32 32" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                            <g id="SVGRepo_iconCarrier"> <path d="M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z" transform="translate(0 0)"/> <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" fill="#FC6020" /> </g>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="space-x-6">
                  <Button size="sm" variant="primary" startIcon={( showLoginLoader ? null : <CheckLineIcon />)}>
                  {(
                    showLoginLoader 

                    ? 

                    <span class="animate-spin" ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" cx="10" cy="10" r="8.75" stroke="white" stroke-width="2.5"></circle><mask id="path-2-inside-1_3755_26472" fill="white"><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z"></path></mask><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z" stroke="white" stroke-width="4" mask="url(#path-2-inside-1_3755_26472)"></path></svg></span>

                    : 
                    
                    null
                  )}
                    Submit
                  </Button>
                  <Button size="sm" onClick={resetForm} variant="outline" startIcon={<CloseLineIcon />}>
                    Cancel
                  </Button>
              </div>
            </div>
            </form>
          </ComponentCard>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
